/* eslint-disable react/prop-types */

import React from "react";
import Img from "gatsby-image";

import wireframe from "~assets/images/wireframe.png";

const Gallery = ({ section, title, sectionKey }) => {
  const colorClasses = `bg-${section.backgroundColor} border-t-${section.borderTop} text-${section.fontColor}`;

  return (
    <section
      className={`case-study-gallery w-full relative block pt-v7 pb-v14 xs:pt-v14 xs:pb-v28 ${colorClasses}`}
    >
      <div className="w-full relative">
        {section?.rows?.[0] &&
          section.rows.map((row, rowIndex) => {
            const imageKey = `${sectionKey}-row-${rowIndex}`;

            let imageJSX;

            //

            switch (row.type) {
              case `one`:
                imageJSX = (
                  <section key={sectionKey} className="grid">
                    <figure
                      key={imageKey}
                      className="case-study-page__image grid-end-12 relative"
                    >
                      <img
                        className="case-study-page__image__wireframe w-full h-full absolute transform-center"
                        src={wireframe}
                        alt="Wireframe"
                      />

                      {(row?.image?.childImageSharp?.fluid && (
                        <Img
                          className="case-study-page__image__src w-full relative z-10 block"
                          fluid={row?.image.childImageSharp.fluid}
                          alt={`${`${title} Taglines`}`}
                        />
                      )) || (
                        <>
                          {row?.image?.publicURL && (
                            <img
                              className="case-study-page__image__src w-full relative z-10 block"
                              src={row?.image.publicURL}
                              alt={`${`${title} Taglines`}`}
                            />
                          )}
                        </>
                      )}
                    </figure>
                  </section>
                );

                break;

              case `two`:
                imageJSX = (
                  <section key={sectionKey} className="grid">
                    <figure
                      key={imageKey}
                      className="case-study-page__image grid-end-12 relative"
                    >
                      <img
                        className="case-study-page__image__wireframe w-full h-full absolute transform-center"
                        src={wireframe}
                        alt="Wireframe"
                      />

                      {(row?.imageTop?.childImageSharp?.fluid && (
                        <Img
                          className="case-study-page__image__src w-full relative z-10 block"
                          fluid={row?.imageTop.childImageSharp.fluid}
                          alt={`${`${title} Taglines`}`}
                        />
                      )) || (
                        <>
                          {row?.imageTop?.publicURL && (
                            <img
                              className="case-study-page__image__src w-full relative z-10 block"
                              src={row?.imageTop.publicURL}
                              alt={`${`${title} Taglines`}`}
                            />
                          )}
                        </>
                      )}
                    </figure>

                    <figure
                      key={imageKey}
                      className="case-study-page__image grid-end-12 relative"
                    >
                      <img
                        className="case-study-page__image__wireframe w-full h-full absolute transform-center"
                        src={wireframe}
                        alt="Wireframe"
                      />

                      {(row?.imageBottom?.childImageSharp?.fluid && (
                        <Img
                          className="case-study-page__image__src w-full relative z-10 block"
                          fluid={row?.imageBottom.childImageSharp.fluid}
                          alt={`${`${title} Taglines`}`}
                        />
                      )) || (
                        <>
                          {row?.imageBottom?.publicURL && (
                            <img
                              className="case-study-page__image__src w-full relative z-10 block"
                              src={row?.imageBottom.publicURL}
                              alt={`${`${title} Taglines`}`}
                            />
                          )}
                        </>
                      )}
                    </figure>
                  </section>
                );

                break;

              case `three`:
                imageJSX = (
                  <section key={sectionKey} className="grid items-stretch">
                    <figure
                      key={imageKey}
                      className="case-study-page__image grid-end-12 xs:grid-end-8 relative"
                    >
                      <img
                        className="case-study-page__image__wireframe w-full h-full absolute transform-center"
                        src={wireframe}
                        alt="Wireframe"
                      />

                      {(row?.imageLeft?.childImageSharp?.fluid && (
                        <Img
                          className="case-study-page__image__src w-full h-full relative z-10 block object-cover"
                          fluid={row?.imageLeft.childImageSharp.fluid}
                          alt={`${`${title} Taglines`}`}
                        />
                      )) || (
                        <>
                          {row?.imageLeft?.publicURL && (
                            <img
                              className="case-study-page__image__src w-full h-full relative z-10 block object-cover"
                              src={row?.imageLeft.publicURL}
                              alt={`${`${title} Taglines`}`}
                            />
                          )}
                        </>
                      )}
                    </figure>

                    <figure
                      key={imageKey}
                      className="case-study-page__image tall grid-end-6 xs:grid-end-8 relative"
                    >
                      <img
                        className="case-study-page__image__wireframe w-full h-full absolute transform-center"
                        src={wireframe}
                        alt="Wireframe"
                      />

                      {(row?.imageLeft?.childImageSharp?.fluid && (
                        <Img
                          className="case-study-page__image__src w-full h-full relative z-10 block object-cover"
                          fluid={row?.imageLeft.childImageSharp.fluid}
                          alt={`${`${title} Taglines`}`}
                        />
                      )) || (
                        <>
                          {row?.imageLeft?.publicURL && (
                            <img
                              className="case-study-page__image__src w-full h-full relative z-10 block object-cover"
                              src={row?.imageLeft.publicURL}
                              alt={`${`${title} Taglines`}`}
                            />
                          )}
                        </>
                      )}
                    </figure>

                    <figure
                      key={imageKey}
                      className="case-study-page__image tall grid-end-6 xs:grid-end-8 relative"
                    >
                      <img
                        className="case-study-page__image__wireframe w-full h-full absolute transform-center"
                        src={wireframe}
                        alt="Wireframe"
                      />

                      {(row?.imageLeft?.childImageSharp?.fluid && (
                        <Img
                          className="case-study-page__image__src w-full h-full relative z-10 block object-cover"
                          fluid={row?.imageLeft.childImageSharp.fluid}
                          alt={`${`${title} Taglines`}`}
                        />
                      )) || (
                        <>
                          {row?.imageLeft?.publicURL && (
                            <img
                              className="case-study-page__image__src w-full h-full relative z-10 block object-cover"
                              src={row?.imageLeft.publicURL}
                              alt={`${`${title} Taglines`}`}
                            />
                          )}
                        </>
                      )}
                    </figure>
                  </section>
                );

                break;

              case `four`:
                imageJSX = (
                  <section key={sectionKey} className="grid items-stretch">
                    <figure
                      key={imageKey}
                      className="case-study-page__image grid-end-12 xs:grid-end-8 relative"
                    >
                      <img
                        className="case-study-page__image__wireframe w-full h-full absolute transform-center"
                        src={wireframe}
                        alt="Wireframe"
                      />

                      {(row?.imageTop?.childImageSharp?.fluid && (
                        <Img
                          className="case-study-page__image__src w-full h-full relative z-10 block object-cover"
                          fluid={row?.imageTop.childImageSharp.fluid}
                          alt={`${`${title} Taglines`}`}
                        />
                      )) || (
                        <>
                          {row?.imageTop?.publicURL && (
                            <img
                              className="case-study-page__image__src w-full h-full relative z-10 block object-cover"
                              src={row?.imageTop.publicURL}
                              alt={`${`${title} Taglines`}`}
                            />
                          )}
                        </>
                      )}
                    </figure>
                    <figure
                      key={imageKey}
                      className="case-study-page__image tall grid-end-6 xs:grid-end-8 relative"
                    >
                      <img
                        className="case-study-page__image__wireframe w-full h-full absolute transform-center"
                        src={wireframe}
                        alt="Wireframe"
                      />

                      {(row?.imageLeft?.childImageSharp?.fluid && (
                        <Img
                          className="case-study-page__image__src w-full h-full relative z-10 block object-cover"
                          fluid={row?.imageLeft.childImageSharp.fluid}
                          alt={`${`${title} Taglines`}`}
                        />
                      )) || (
                        <>
                          {row?.imageLeft?.publicURL && (
                            <img
                              className="case-study-page__image__src w-full h-full relative z-10 block object-cover"
                              src={row?.imageLeft.publicURL}
                              alt={`${`${title} Taglines`}`}
                            />
                          )}
                        </>
                      )}
                    </figure>
                    <div className="relative grid-end-6 xs:grid-end-8 h-full flex flex-col">
                      <figure
                        key={imageKey}
                        className="case-study-page__image relative mb-v2 flex-grow"
                      >
                        <img
                          className="case-study-page__image__wireframe w-full h-full absolute transform-center"
                          src={wireframe}
                          alt="Wireframe"
                        />

                        {(row?.imageRightTop?.childImageSharp?.fluid && (
                          <Img
                            className="case-study-page__image__src w-full h-full relative z-10 block object-cover"
                            fluid={row?.imageRightTop.childImageSharp.fluid}
                            alt={`${`${title} Taglines`}`}
                          />
                        )) || (
                          <>
                            {row?.imageRightTop?.publicURL && (
                              <img
                                className="case-study-page__image__src w-full h-full relative z-10 block object-cover"
                                src={row?.imageRightTop.publicURL}
                                alt={`${`${title} Taglines`}`}
                              />
                            )}
                          </>
                        )}
                      </figure>
                      <figure
                        key={imageKey}
                        className="case-study-page__image relative flex-grow"
                      >
                        <img
                          className="case-study-page__image__wireframe w-full h-full absolute transform-center"
                          src={wireframe}
                          alt="Wireframe"
                        />

                        {(row?.imageRightBottom?.childImageSharp?.fluid && (
                          <Img
                            className="case-study-page__image__src w-full h-full relative z-10 block object-cover"
                            fluid={row?.imageRightBottom.childImageSharp.fluid}
                            alt={`${`${title} Taglines`}`}
                          />
                        )) || (
                          <>
                            {row?.imageRightBottom?.publicURL && (
                              <img
                                className="case-study-page__image__src w-full h-full relative z-10 block object-cover"
                                src={row?.imageRightBottom.publicURL}
                                alt={`${`${title} Taglines`}`}
                              />
                            )}
                          </>
                        )}
                      </figure>
                    </div>
                  </section>
                );

                break;

              default:
                break;
            }

            //

            return imageJSX;
          })}
      </div>
    </section>
  );
};

export default Gallery;
